import { REALTIME_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const CAMPAIGN_REALTIME_REPORT_ID = `campaign${REALTIME_CAMPAIGN_SUFFIX}`;
